import { Stack as MuiStack, StackProps } from '@mui/material';

export const Stack = ({ children, ...otherProps }: StackProps) => {
  return <MuiStack {...otherProps}>{children}</MuiStack>;
};
